module.exports = __webpack_public_path__ + "img/estate-slim.c49c9c55.svg";